import React from 'react';
import Cookies from 'js-cookie';
import { Navigate } from 'react-router-dom';

// استيراد Store باستخدام require
const store = require('../../../Store').default;
console.log('LogoutButton: Store imported successfully:', !!store);

export default class Logout extends React.Component<{}, { loggedOut: boolean }> {
  constructor(props: {}) {
    super(props);
    this.state = {
      loggedOut: false,
    };
    console.log('LogoutButton: Component created, store available:', !!store);
  }

  async componentDidMount() {
    console.log('Logout: Starting logout process...');
    console.log('Logout: Store available:', !!store);
    
    // استخدام Store logout إذا كان متاحاً
    if (store && store.logout) {
      await store.logout();
    } else {
      console.log('Logout: Store not available, clearing manually');
      // مسح localStorage يدوياً
      localStorage.removeItem('admin_token');
    }
    
    // حذف الكوكيز
    Cookies.remove('token');
    Cookies.remove('id');
    Cookies.remove('role');
    
    console.log('Logout: All tokens and cookies cleared');

    // تعيين الحالة لتفعيل التوجيه
    this.setState({ loggedOut: true });
  }

  render() {
    console.log('LogoutButton: Render called, loggedOut:', this.state.loggedOut);
    if (this.state.loggedOut) {
      console.log('LogoutButton: Redirecting to login');
      return <Navigate to="/" replace />;
    }

    return null; // لا نعرض أي شيء أثناء المعالجة
  }
}
